import { dropCursorConfig, cursor } from '@milkdown/kit/plugin/cursor';

const defineFeature = (editor, config) => {
  editor.config((ctx) => {
    ctx.update(dropCursorConfig.key, () => {
      var _a, _b;
      return {
        class: "crepe-drop-cursor",
        width: (_a = config == null ? void 0 : config.width) != null ? _a : 4,
        color: (_b = config == null ? void 0 : config.color) != null ? _b : false
      };
    });
  }).use(cursor);
};

export { defineFeature };
//# sourceMappingURL=index-6JoGWH2I.js.map
